const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/comment/v1frontend/comment-facebook/search', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
